module.exports = function getResource(label, vars = []) {
    let resources = {
        pageNotCurrentlyAvailable: 'This page is not currently available. Please try again later.',
        continueShopping: 'Continue Shopping'
    };
    return resources[label];
};
